/**
 * Different types of sources supported by MKPlayer.
 */
export enum MKAssetType {
    /**
     * Asset type is 24x7 live service.
     */
    Live = "live",

    /**
     * Asset type is live event with a fixed start time and no defined end time.
     */
    Event = "event",

    /**
     * Asset type is RestartTV or Catchup.
     */
    Catchup = "catchup",

    /**
     * Asset type is DVR.
     */
    DVR = "dvr",

    /**
     * Asset type is VOD.
     */
    VOD = "vod"
}